import { Task } from '@models/task.model';

/**
 * Creation-time nesting limit (a subtask tree may be at most this deep). Single declaration for
 * the web client; governs the capped walk and nesting check in `DependenciesTab`. It does NOT cap
 * `getAncestorTaskIds` below (sprint 40, story-218, decision D2).
 */
export const MAX_PARENT_DEPTH = 10;

/**
 * Walk up the parentTaskId chain. Used to forbid a subtask from depending on its own parent /
 * ancestor (would create an unresolvable date constraint since a subtask is contained within its
 * parent's date range). Covers the whole chain, guarded by a visited set instead of a depth cap,
 * so a cycle terminates and a deep chain is never truncated.
 */
export const getAncestorTaskIds = (
  task: Task | null | undefined,
  allTasks: Task[],
): Set<string> => {
  const ancestors = new Set<string>();
  if (!task) return ancestors;
  const visited = new Set<string>();
  let currentParentId = task.parentTaskId;
  while (currentParentId && !visited.has(currentParentId)) {
    const parentId = currentParentId;
    visited.add(parentId);
    ancestors.add(parentId);
    const parent = allTasks.find((t) => t.taskId === parentId);
    if (!parent) break;
    currentParentId = parent.parentTaskId;
  }
  return ancestors;
};
